import React from 'react'
import DocumentHeaderLoader from '../../general/documentHeader/_load/DocumentHeaderLoader'
import HeaderContent from './HeaderContent'

export default function HeaderImage() {
  return (
    <DocumentHeaderLoader>
      <HeaderContent />
    </DocumentHeaderLoader>
  )
}
